import React from 'react';
import { Icon } from 'ui';

const TopicBadge = () => (
  <span className="Pill Pill--small d-ib fw-b bg-gray-light c-brand-gray-darker">
    <Icon name="tags" className="mr-4" />
    {t('learning_library.topic')}
  </span>
);

export default TopicBadge;
